import React from "react";
import FrontPage from "../../../Components/FrontPage/FrontPage";
import { useAuth } from "../../../providers/AuthProvider";

export default () => {
  const { referrer, setReferrer } = useAuth();

  const handleLoginSuccess = () => {
    if (referrer) {
      setReferrer(null);
      document.location.href = referrer;
    } else {
      document.location.href = "/sections/packages/";
    }
  };

  const handleLoginSuccessNewCode = () => {
    document.location.href = "/sections/packages/";
  };

  return (
    <FrontPage
      handleLoginSuccess={handleLoginSuccess}
      handleLoginSuccessNewCode={handleLoginSuccessNewCode}
    />
  );
};
